import { render, staticRenderFns } from "./UnSuspendApproval.vue?vue&type=template&id=821ecfca&scoped=true"
import script from "./UnSuspendApproval.vue?vue&type=script&lang=js"
export * from "./UnSuspendApproval.vue?vue&type=script&lang=js"
import style0 from "./UnSuspendApproval.vue?vue&type=style&index=0&id=821ecfca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821ecfca",
  null
  
)

export default component.exports